module.exports = __webpack_public_path__ + "static/hon-hyosi-119cef6927e70a92f3fb73a1f93086c9.jpg";